import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeguroPrivadoRoutingModule } from './seguro-privado-routing.module';
import { SeguroPrivadoResumenComponent } from './pages/seguro-privado-resumen/seguro-privado-resumen.component';
import { CardSeguroPrivadoComponent } from './components/card-seguro-privado/card-seguro-privado.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SeguroPrivadoMainComponent } from './pages/seguro-privado-main/seguro-privado-main.component';
import { SeguroPrivadoDetalleComponent } from './pages/seguro-privado-detalle/seguro-privado-detalle.component';
import { TabResumenComponent } from './components/tab-resumen/tab-resumen.component';
import {
  CardBeneficiariosComponent,
  DataBeneficiarioModalComponent,
} from './components/card-beneficiarios/card-beneficiarios.component';
import { TabLiquidacionesComponent } from './components/tab-liquidaciones/tab-liquidaciones.component';
import { LiquidacionesModalComponent } from './components/tab-liquidaciones/liquidaciones-modal/liquidaciones-modal.component';
import { TutorLegalComponent } from './components/tutor-legal/tutor-legal.component';
import { CardContratanteVitaliciaComponent } from './components/card-contratante-vitalicia/card-contratante-vitalicia.component';
import { CardAseguradoComponent } from './components/card-asegurado/card-asegurado.component';

@NgModule({
  declarations: [
    SeguroPrivadoResumenComponent,
    CardSeguroPrivadoComponent,
    SeguroPrivadoMainComponent,
    SeguroPrivadoDetalleComponent,
    TabResumenComponent,
    CardBeneficiariosComponent,
    TabLiquidacionesComponent,
    LiquidacionesModalComponent,
    TutorLegalComponent,
    CardContratanteVitaliciaComponent,
    CardAseguradoComponent,
    DataBeneficiarioModalComponent,
  ],
  entryComponents: [
    LiquidacionesModalComponent,
    DataBeneficiarioModalComponent,
  ],
  imports: [CommonModule, SeguroPrivadoRoutingModule, SharedModule],
})
export class SeguroPrivadoModule {}
